module.exports = __webpack_public_path__ + "img/5.0c0d36c9.jpg";